import { useCallback, useEffect, useRef } from 'react';

export const useOnClickOutside = (onClickOutside: () => void) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClose = useCallback(
    (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        onClickOutside();
      }
    },
    [onClickOutside],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClose);

    return () => document.removeEventListener('mousedown', handleClose);
  }, [handleClose]);

  return wrapperRef;
};
